import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../api/client';

export interface DashboardStats {
  investors_total: number;
  profiles_total: number;
  investors_not_verified: number;
  investors_not_approved: number;
  mandates_total: number;
  mandates_active: number;
  mandates_volume_total_eur: number;
  mandates_volume_active_eur: number;
  mach_total: number;
  mach_in_arbeit: number;
  mach_neu: number;
}

export function useDashboardStats() {
  return useQuery<DashboardStats>({
    queryKey: ['dashboard-stats'],
    queryFn: async () => {
      const { data } = await apiClient.get('/dashboard/stats');
      return data.data;
    },
    staleTime: 30_000,
  });
}

export interface ProfileHistogramBucket {
  bucket: string;
  investors: number;
}

export interface CoverageByInvestorType {
  type: string;
  total: number;
  with_profile: number;
  with_haupt: number;
  with_any_contact: number;
}

export interface InvestorsByCountry {
  country: string;
  investors: number;
}

export interface ProfileCoverage {
  investors_total: number;
  investors_with_website: number;
  investors_without_website: number;
  investors_with_investor_type: number;
  investors_without_investor_type: number;
  investors_without_country: number;
  investors_with_profile: number;
  investors_without_profile: number;
  profiles_total_active: number;
  profiles_approved: number;
  profiles_review_backlog: number;
  investors_with_hauptansprechpartner: number;
  investors_with_any_communicating_contact: number;
  investors_with_any_contact: number;
  investors_without_any_contact: number;
  contacts_total: number;
  contacts_review_backlog: number;
  contacts_hauptansprechpartner: number;
  profile_histogram: ProfileHistogramBucket[];
  coverage_by_investor_type: CoverageByInvestorType[];
  investors_by_country: InvestorsByCountry[];
}

export function useProfileCoverage() {
  return useQuery<ProfileCoverage>({
    queryKey: ['dashboard-profile-coverage'],
    queryFn: async () => {
      const { data } = await apiClient.get('/dashboard/profile-coverage');
      return data.data;
    },
    staleTime: 60_000,
  });
}
